export default "__VITE_PUBLIC_ASSET__f300a924__"